const turquoise = {
  100: '#1BBC9B'
};

export { turquoise };
